/**
 * Dashboard sub-tab — STUB for web v1.
 *
 * The mobile Dashboard has rich P&L charting (income vs expense
 * over time, category breakdown pie, period chips, PDF export).
 * Web v1 ships the MTD totals + a pointer to the mobile app for
 * full charts. Manager doesn't see this tab at all per role
 * matrix; this is for SA / Admin / Accountant.
 *
 * Replace with full chart suite in a follow-up — the data hooks
 * (`useOrgFinancesTotals`, project transaction totals) are ready.
 */
import {
  useOrgFinancesTotals,
} from '@/lib/orgFinances';

function fmtInr(n: number): string {
  return `₹${Math.round(n).toLocaleString('en-IN')}`;
}

export function DashboardTabStub({ orgId }: { orgId: string | null }) {
  const { mtd, loading } = useOrgFinancesTotals(orgId);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
          gap: 12,
        }}
      >
        <Kpi label="MTD Income"   value={mtd.income}   tint="#10B981" loading={loading} />
        <Kpi label="MTD Expense"  value={mtd.expense}  tint="#EF4444" loading={loading} />
        <Kpi label="MTD Salaries" value={mtd.salaries} tint="#F59E0B" loading={loading} />
        <Kpi label="Net"          value={mtd.net}      tint={mtd.net >= 0 ? '#10B981' : '#EF4444'} loading={loading} />
      </div>

      <div
        className="card"
        style={{
          padding: 24,
          border: '1px solid var(--border)',
          borderRadius: 12,
          background: 'var(--surface)',
          textAlign: 'center',
        }}
      >
        <i
          className="ph ph-chart-pie-slice"
          style={{ fontSize: 36, color: 'var(--text-tertiary)', opacity: 0.6 }}
        />
        <div style={{ marginTop: 12, fontWeight: 600, fontSize: 15 }}>
          Full P&amp;L charts coming to web
        </div>
        <div
          style={{
            marginTop: 4,
            fontSize: 13,
            color: 'var(--text-secondary)',
            maxWidth: 420,
            margin: '4px auto 0',
          }}
        >
          Open InteriorIO on iOS or Android for the full Dashboard
          with monthly P&amp;L, income-vs-expense over time, and PDF
          export. Web Dashboard is a quick-look summary for now.
        </div>
      </div>
    </div>
  );
}

function Kpi({
  label,
  value,
  tint,
  loading,
}: {
  label: string;
  value: number;
  tint: string;
  loading: boolean;
}) {
  return (
    <div
      className="card"
      style={{
        padding: 14,
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderLeft: `4px solid ${tint}`,
        borderRadius: 10,
      }}
    >
      <div style={{ fontSize: 11, color: 'var(--text-secondary)', letterSpacing: 0.4 }}>
        {label}
      </div>
      <div style={{ marginTop: 6, fontSize: 22, fontWeight: 700, color: 'var(--text-primary)' }}>
        {loading ? '—' : fmtInr(value)}
      </div>
    </div>
  );
}
